import { axiosRequest, formatE164 } from "helpers";

export const ownerService = {
	sendOwner
};

const API_URL = process.env.REACT_APP_API_URL;

function sendOwner(model) {
	const options = {
		method: "POST",
		data: {
			...model,
			phone_number: formatE164(model?.phone_number),
		},
		params: {
			token: model?.token,
		},
		url: `${API_URL}/api/pre_applications/${model?.applicationId}/owner`,
	};
	return axiosRequest(options);
}
